import { Step } from '../components/steps/Step';
import { OnboardingFlows } from './common';

export const contentTypeRnDDepartment: Step = {
    id: OnboardingFlows.UseCases,
    title: 'How do you plan to use D-ID?',
    showCondition: {
        stepId: OnboardingFlows.NewDepartment,
        selectedOption: 'R&D (development, engineering)',
    },
    multiSelect: false,
    randomize: true,
    options: [
        {
            label: 'Ai Agent',
        },
        {
            label: 'Marketing',
        },
        {
            label: 'Learning & Development',
        },
        {
            label: 'Sales',
        },
        {
            label: 'In-App',
        },
        {
            label: 'Customer Support',
        },
        {
            label: 'Content Creation',
        },
        {
            label: 'AI innovation',
        },
        {
            label: 'Other',
        },
    ],
};
